import PropTypes from 'prop-types';

const searchFormPropTypes = {
  userDefaultHotel: PropTypes.string,
  hotelCode: PropTypes.string,
  hotelsList: PropTypes.arrayOf(PropTypes.object),
  operatorCode: PropTypes.string,
  operatorsList: PropTypes.arrayOf(PropTypes.object),
  locatorTTOO: PropTypes.string,
  lockSearchForm: PropTypes.bool,
  setHotelFilter: PropTypes.func,
  setOperatorFilter: PropTypes.func,
  setLocatorTTOOFilter: PropTypes.func,
  getMealPlansList: PropTypes.func,
  getTourOperatorsList: PropTypes.func,
  getRoomsListByTourOperator: PropTypes.func,
  getContractsList: PropTypes.func,
  getReservationsList: PropTypes.func,
  getHotelGroups: PropTypes.func,
  handleSearchAction: PropTypes.func,
  handleModalMessages: PropTypes.func
};

const searchFormDefaultProps = {
  userDefaultHotel: '',
  hotelCode: '',
  hotelsList: [],
  operatorCode: '',
  operatorsList: [],
  locatorTTOO: '',
  lockSearchForm: false,
  setHotelFilter: () => {},
  setOperatorFilter: () => {},
  setLocatorFilter: () => {},
  getMealPlansList: () => {},
  getTourOperatorsList: () => {},
  getRoomsListByTourOperator: () => {},
  getContractsList: () => {},
  getReservationsList: () => {},
  getHotelGroups: () => {},
  handleSearchAction: () => {},
  handleModalMessages: () => {}
};

export { searchFormPropTypes, searchFormDefaultProps };
